export default [
  {
    path: '/rent/v2/thirdLogin',
    name: 'thirdLogin',
    component: () => import('@/pages/thirdLogin/thirdLogin.vue'),
    meta: { title: '第三方登录', requireAuth: true },
  }
]


// WEBPACK FOOTER //
// ./src/pages/thirdLogin/thirdLogin.js